import React, { useState, useRef, useEffect } from "react";
import { countryCodes } from "./CountryCodes";
import MeetingService from "./services/MeetingService";
import { ToastContainer } from "react-toastify";



const App = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    countryCode: "91",
    meetingDate: "",
    meetingTime: "",
    meetingDuration: "",
    reason: "",
    email: "",
  });

  const [loading , setLoading] = useState(false);
  const [success , setSuccess] = useState(null);
  const [errorFill , setErrorfill] = useState(false);
  const [dialOpen, setDialOpen] = useState(false);
  const [dialSearch, setDialSearch] = useState("");
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const dialRef = useRef(null);
  const dialBtnRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dialRef.current && !dialRef.current.contains(e.target)) {
        setDialOpen(false);
        setDialSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredDial = countryCodes.filter(
    (c) =>
      c.name.toLowerCase().includes(dialSearch.toLowerCase()) ||
      c.code.includes(dialSearch)
  );

  const onSubmit = async () => {
    if (
      formData.lastName === "" ||
      formData.firstName === "" ||
      formData.phoneNumber === "" ||
      formData.reason === "" ||
      formData.email === ""
    ) {
      setErrorfill("Please fill all the fields");
      return;
    }

    const email = formData.email;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrorfill("Please enter a valid email address");
      return;
    }
    setLoading(true)
    try {
      const response = await MeetingService.postMeetingRequest(formData);
      setSuccess(response.data);
      setFormData({
        lastName: "",
        firstName: "",
        phoneNumber: "",
        countryCode: "+91",

        meetingDuration: "",
        reason: "",
        email: "",
      });
      setTimeout(()=>{
        setSuccess("")
      },2000)
    } catch (err) {
      console.log(err);
    }finally{
      setLoading(false)
      
    }
  };

  return (
    <div className="relative h-screen bg-black flex items-center justify-center overflow-hidden">
      <ToastContainer />

      <div className="flex items-center w-full px-6 justify-center">
        <div className="bg-[#111111] z-50 w-full md:w-[70%] lg:w-[55%] p-6 md:p-8 rounded-[20px] shadow-lg font-roboto max-h-[96vh] overflow-y-auto">
          <div className="flex flex-col items-center text-center justify-center">
            <h1 className="text-[22px] md:text-[26px] text-white font-medium mb-3 md:mb-4 font-playfair">
              Request for the meeting
            </h1>
            <div className="text-[12px] md:text-[13px] text-gray-300">
              Thank you for your interest in meeting with Mr.Ponnusamy Karthik
              . Please fill out the form to request a meeting. Once your
              request is submitted, it will be reviewed by our admin team.
              Please note that the meeting will only be confirmed after
              approval. You will receive a notification once your request is
              accepted. We appreciate your patience and will get back to you as
              soon as possible.
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mt-5">
            <div className="flex flex-col gap-1">
              <label className="text-[12px] md:text-[13px] text-gray-200">
                First Name <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                maxLength={50}
                className="w-full border border-gray-600 bg-[#222222] text-white placeholder-gray-500 rounded-lg p-2 mt-1 text-sm focus:outline-none focus:border-yellow-400"
                placeholder="Enter your first name"
                value={formData.firstName}
                onChange={(e) =>
                {
                  setFormData({ ...formData, firstName: e.target.value })
                  setErrorfill("")
                }
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] md:text-[13px] text-gray-200">
                Last Name <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                maxLength={50}
                className="w-full border border-gray-600 bg-[#222222] text-white placeholder-gray-500 rounded-lg p-2 mt-1 text-sm focus:outline-none focus:border-yellow-400"
                placeholder="Enter your last name"
                value={formData.lastName}
                onChange={(e) =>
                 {
                  setFormData({ ...formData, lastName: e.target.value })
                  setErrorfill("")
                 }
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] md:text-[13px] text-gray-200">
                Phone <span className="text-red-400">*</span>
              </label>
              <div className="flex items-center gap-2">
                <div className="relative mt-1" ref={dialRef}>
                  <button
                    type="button"
                    ref={dialBtnRef}
                    onClick={() => {
                      if (!dialOpen && dialBtnRef.current) {
                        const rect = dialBtnRef.current.getBoundingClientRect();
                        setDropdownPos({ top: rect.bottom + 4, left: rect.left });
                      }
                      setDialOpen(!dialOpen);
                      setDialSearch("");
                    }}
                    className="flex items-center gap-1 w-[80px] border border-gray-600 bg-[#222222] text-white rounded-lg px-2 py-2 text-sm focus:outline-none focus:border-yellow-400 hover:border-yellow-400 transition-colors"
                  >
                    <span className="text-sm flex-1 text-left">+{formData.countryCode}</span>
                    <span className="text-gray-400 text-xs">{dialOpen ? "▲" : "▼"}</span>
                  </button>
                  {dialOpen && (
                    <div
                      style={{ position: "fixed", top: dropdownPos.top, left: dropdownPos.left }}
                      className="z-[9999] w-[220px] bg-[#1a1a1a] border border-gray-600 rounded-lg shadow-xl overflow-hidden"
                    >
                      <div className="p-2 border-b border-gray-700">
                        <input
                          type="text"
                          autoFocus
                          placeholder="Search country..."
                          value={dialSearch}
                          onChange={(e) => setDialSearch(e.target.value)}
                          className="w-full bg-[#2a2a2a] text-white text-sm placeholder-gray-500 rounded-md px-3 py-2 focus:outline-none focus:border-yellow-400 border border-gray-600"
                        />
                      </div>
                      <ul className="max-h-48 overflow-y-auto">
                        {filteredDial.length > 0 ? filteredDial.map((country) => (
                          <li
                            key={country.code}
                            onClick={() => {
                              setFormData({ ...formData, countryCode: country.code });
                              setDialOpen(false);
                              setDialSearch("");
                            }}
                            className={`flex items-center gap-3 px-3 py-2 cursor-pointer text-sm hover:bg-[#2a2a2a] transition-colors ${
                              formData.countryCode === country.code ? "bg-[#2a2a2a] text-yellow-400" : "text-white"
                            }`}
                          >
                            <span className="font-medium w-[40px] text-yellow-300">+{country.code}</span>
                            <span className="text-gray-300">{country.name}</span>
                          </li>
                        )) : (
                          <li className="px-3 py-3 text-gray-500 text-sm text-center">No results</li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  maxLength={15}
                  className="w-full border border-gray-600 bg-[#222222] text-white placeholder-gray-500 rounded-lg p-2 mt-1 text-sm focus:outline-none focus:border-yellow-400"
                  placeholder="Enter your phone no"
                  value={formData.phoneNumber}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, ""); 
                    setFormData({ ...formData, phoneNumber: numericValue });
                    setErrorfill("") 
                  }}
                />
              </div>
            </div>
            {/* <div className="flex flex-col gap-1">
              <label className="text-[14px] md:text-[16px] text-gray-600">
                Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-3 mt-2 focus:outline-none focus:border-primary"
                value={formData.meetingDate}
                onChange={(e) => setFormData({ ...formData, meetingDate: e.target.value })}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[14px] md:text-[16px] text-gray-600">
                Time <span className="text-red-500">*</span>
              </label>
              <input
                type="time"
                className="w-full border border-gray-300 rounded-lg p-3 mt-2 focus:outline-none focus:border-primary"
                value={formData.meetingTime}
                onChange={(e) => setFormData({ ...formData, meetingTime: e.target.value })}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[14px] md:text-[16px] text-gray-600">
                Duration <span className="text-red-500">*</span>
              </label>
              <select
                value={formData.meetingDuration}
                onChange={(e) => setFormData({ ...formData, meetingDuration: e.target.value })}
                className="w-full border border-gray-300 rounded-lg p-3 mt-2 focus:outline-none focus:border-primary"
              >
                <option value="">Select duration</option>
                <option value="30">30 minutes</option>
                <option value="45">45 minutes</option>
                <option value="60">60 minutes</option>
                <option value="120">120 minutes</option>
                <option value="180">180 minutes</option>

              </select>
            </div> */}
            <div className="flex flex-col gap-1">
              <label className="text-[12px] md:text-[13px] text-gray-200">
                Email <span className="text-red-400">*</span>
              </label>
              <input
                type="email"
                className="w-full border border-gray-600 bg-[#222222] text-white placeholder-gray-500 rounded-lg p-2 mt-1 text-sm focus:outline-none focus:border-yellow-400"
                placeholder="Enter your Email"
                value={formData.email}
                onChange={(e) =>
                {
                  setFormData({ ...formData, email: e.target.value })
                  setErrorfill("")
                
                }
                }
              />
            
            </div>
          </div>
          <div className="mt-3">
            <label className="text-[12px] md:text-[13px] text-gray-200">
              Reason for the Meeting <span className="text-red-400">*</span>
            </label>
            <textarea
              rows="3"
              maxLength={350}
              className="w-full border border-gray-600 bg-[#222222] text-white placeholder-gray-500 rounded-lg p-2 mt-1 text-sm focus:outline-none focus:border-yellow-400"
              placeholder="Enter the purpose of the meeting"
              value={formData.reason}
              onChange={(e) =>
               {
                setFormData({ ...formData, reason: e.target.value })
                setErrorfill("")
               }
              }
            ></textarea>
          </div>
          <div className="flex flex-col items-center justify-center mt-3">
            <div className="mb-2">
            {success && <p className="text-yellow-400 text-sm">{success}</p>}
            {errorFill && <p className="text-red-500 text-sm">{errorFill}</p>}
            </div>
            <button
              onClick={onSubmit}
              disabled={loading}
              className={`w-full ${loading ? "bg-gray-700 text-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-[#FFE700] to-[#C68E00] text-black font-semibold hover:opacity-90"} px-6 py-2 rounded-lg transition-all duration-300 text-sm`}
                      >
              Send Appointment Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
